import api from './axiosInstance';
export const getAll = (params) => api.get('/materials', { params });
export const getById = (id) => api.get(`/materials/${id}`);
export const create = (data) => api.post('/materials', data);
export const update = (id, data) => api.put(`/materials/${id}`, data);
export const remove = (id) => api.delete(`/materials/${id}`);
export const batchRemove = (ids) => api.post('/materials/batch-delete', { ids });
